import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Box, Link, Theme, Typography, useMediaQuery } from "@mui/material";
import { InvestmentsCard } from "@components";
import { DepotsCard } from "./DepotsCard/DepotsCard";

const AssetsContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(2.5)};
  margin-top: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
  }
`;

const AssetsHeaderWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const AssetsHeader = styled(Typography)``;

interface AssetsProps {
  investmentsCount: number;
  currency: string;
}

export const Assets = (props: AssetsProps) => {
  const { investmentsCount, currency } = props;
  const { t } = useTranslation();
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const toInvestments = () => navigate("/investments");

  return (
    <AssetsContainer>
      <Box width={isMd ? "100%" : "45%"}>
        <InvestmentsCard
          title={t("kpmg.dashboard.portfolio")}
          investmentsCount={investmentsCount}
          currency={currency}
          onAddAccountsClick={() => {
            navigate("/import-bank-connection/select-bank");
          }}
          onClick={toInvestments}
        />
      </Box>
      <Box width={isMd ? "100%" : "55%"} flexShrink={0}>
        <AssetsHeaderWrapper>
          <AssetsHeader variant="body4" color="textSecondary" fontWeight={600}>
            {t("kpmg.dashboard.kicksReportingTitle")}
          </AssetsHeader>
          <Link onClick={toInvestments} underline="hover">
            <Typography variant="body4">
              {t("dashboardPage.investmentsLink")}
            </Typography>
          </Link>
        </AssetsHeaderWrapper>
        <DepotsCard />
      </Box>
    </AssetsContainer>
  );
};
